export default "__VITE_ASSET__CvR1PGQs__"